import { getCdnUrl } from '@/utils/url';
import { MenuItem, MobileMenuItems } from './types';
export const SearchDrawerName = 'header-search';
export const HeaderDrawerName = 'header-drawer';
export const HEADER_MENU_NAVIGATE_EVENT = 'toad:header-menu:navigate';
export const MENU_HASH = '#menu';
export const MENU_SEARCH_HASH = '#search';
export const MenuItems: MenuItem[] = [{
  title: 'آرایشی',
  href: '/categories/makeup',
  icon: getCdnUrl('/_toad/app-icons/menu/makeup.svg'),
  id: MobileMenuItems.Makeup,
  isLinkInDrawer: false,
  children: [{
    categories: [{
      title: 'آرایش صورت',
      href: '/face-makeup',
      links: [{
        href: '/bb-cream-cc-cream',
        title: 'کرم BB، کرم CC و DD'
      }, {
        href: '/foundation-makeup',
        title: 'کرم پودر'
      }, {
        href: '/concealer',
        title: 'کانسیلر'
      }, {
        href: '/compact-powder',
        title: 'پنکک'
      }, {
        href: '/blush',
        title: 'رژ گونه'
      }, {
        href: '/makeup-primer',
        title: 'پرایمر صورت'
      }, {
        href: '/makeup-fixture',
        title: 'اسپری و پودر فیکس'
      }, {
        href: '/contour-and-highlight',
        title: 'کانتور'
      }, {
        href: '/highlighter',
        title: 'هایلایتر'
      }, {
        href: '/facial-cushion-and-mousse',
        title: 'موس و کوشن'
      }]
    }]
  }, {
    categories: [{
      title: 'آرایش چشم و ابرو',
      href: '/eye-makeup',
      links: [{
        href: '/mascara',
        title: 'ریمل'
      }, {
        href: '/eyeliner',
        title: 'مداد و خط چشم'
      }, {
        href: '/eyeshadow',
        title: 'سایه چشم'
      }, {
        href: '/eyebrow-gel-and-soap',
        title: 'ژل و صابون ابرو'
      }, {
        href: '/eyebrow-shadow',
        title: 'سایه ابرو'
      }, {
        href: '/eyebrow-liner',
        title: 'مداد و ماژیک ابرو'
      }, {
        href: '/eyebrow-mascara',
        title: 'ریمل ابرو'
      }, {
        href: '/eyebrow-color',
        title: 'رنگ ابرو'
      }, {
        href: '/false-eyelashes',
        title: 'مژه مصنوعی و چسب مژه'
      }, {
        href: '/contact-lens',
        title: 'لنز'
      }]
    }]
  }, {
    categories: [{
      title: 'آرایش لب',
      href: '/lips-makeup',
      links: [{
        href: '/lipstick',
        title: 'رژ لب'
      }, {
        href: '/liquid-lipstick',
        title: 'رژ لب مایع و برق لب'
      }, {
        href: '/lip-liner',
        title: 'مداد و خط لب'
      }, {
        href: '/lip-tint',
        title: 'تینت لب'
      }]
    }, {
      title: 'آرایش ناخن',
      href: '/nail-makeup',
      links: [{
        href: '/nail-polish',
        title: 'لاک ناخن'
      }, {
        href: '/nail-polish-remover',
        title: 'لاک پاک کن'
      }, {
        href: '/nail-tools',
        title: 'ابزار مانیکور و پدیکور'
      }, {
        href: '/nail-accessories',
        title: 'ناخن مصنوعی'
      }, {
        href: '/nail-art-supplies',
        title: 'لوازم طراحی ناخن'
      }, {
        href: '/nail-material',
        title: 'قلم و مواد کاشت ناخن'
      }]
    }]
  }, {
    categories: [{
      title: 'ابزار آرایشی',
      href: '/makeup-accessories',
      links: [{
        href: '/cosmetic-brush-cosmetic-puff',
        title: 'براش و قلمو آرایشی'
      }, {
        href: '/beautyblender',
        title: 'اسفنج و بیوتی بلندر'
      }, {
        href: '/tweezers-scissor',
        title: 'موچین و قیچی ابرو'
      }, {
        href: '/eyebrow-razor',
        title: 'تیغ ابرو'
      }, {
        href: '/eyelash-curler',
        title: 'فرمژه و برس ابرو'
      }, {
        href: '/sharpener',
        title: 'تراش'
      }, {
        href: '/makeup-bag',
        title: 'کیف لوازم آرایشی'
      }, {
        href: '/cosmetic-stands',
        title: 'استند لوازم آرایش'
      }, {
        href: '/pocket-mirror',
        title: 'آینه آرایشی'
      }]
    }]
  }, {
    categories: [{
      title: 'آرایش بدن',
      href: '/body-makeup',
      links: [{
        href: '/self-tanner-bronzer',
        title: 'اتوبرنز و محصولات برنزه کننده'
      }]
    }]
  }]
}, {
  title: 'مراقبت پوست',
  href: '/categories/skincare',
  icon: getCdnUrl('/_toad/app-icons/menu/skin-care.svg'),
  id: MobileMenuItems.SkinCare,
  isLinkInDrawer: false,
  children: [{
    categories: [{
      title: 'مراقبت صورت',
      href: '/face-care',
      links: [{
        href: '/sun-block-sun-protecter',
        title: 'ضد آفتاب'
      }, {
        href: '/moisturizer',
        title: 'آبرسان و مرطوب کننده'
      }, {
        href: '/face-mask',
        title: 'ماسک صورت'
      }, {
        href: '/exfoliator-scrub',
        title: 'اسکراب و لایه بردار صورت'
      }, {
        href: '/day-cream-night-cream',
        title: 'کرم شب و روز'
      }, {
        href: '/tags/face-serum',
        title: 'سرم و روغن صورت',
        useHrefWithoutParent: true
      }, {
        href: '/lightening-for-face',
        title: 'ضد لک و روشن کننده'
      }, {
        href: '/anti-wrinkle-for-face',
        title: 'ضد چروک'
      }, {
        href: '/anti-acne',
        title: 'ضد جوش'
      }, {
        href: '/repairing',
        title: 'ترمیم کننده'
      }, {
        href: '/lifting-for-face',
        title: 'سفت کننده صورت'
      }, {
        href: '/open-pores',
        title: 'درمان منافذ باز'
      }, {
        href: '/anti-redness',
        title: 'ضد التهاب و قرمزی'
      }, {
        href: '/face-mist',
        title: 'فیس میست'
      }, {
        href: '/facial-care-sets',
        title: 'ست مراقبت صورت'
      }]
    }]
  }, {
    categories: [{
      title: 'پاک کننده و شوینده',
      href: '/cleanser',
      links: [{
        href: '/face-wash-toner',
        title: 'شوینده صورت'
      }, {
        href: '/makeup-remover',
        title: 'آرایش پاک کن و میسلار واتر'
      }, {
        href: '/toner',
        title: 'تونر'
      }, {
        href: '/eye-makeup-removers',
        title: 'پاک کننده آرایش چشم'
      }, {
        href: '/cotton-pad',
        title: 'پنبه و پد آرایش پاک کن'
      }, {
        href: '/wet-wipes',
        title: 'دستمال مرطوب'
      }]
    }, {
      title: 'مراقبت چشم و ابرو',
      href: '/eye-and-eyebrow-care',
      links: [{
        href: '/lash-and-eyebrow-strengthener',
        title: 'تقویت مژه و ابرو'
      }, {
        href: '/anti-wrinkle-for-eyes',
        title: 'ضد چروک دور چشم'
      }, {
        href: '/moisturizer-for-eyes',
        title: 'مرطوب کننده دور چشم'
      }, {
        href: '/dark-circle-treatment',
        title: 'ضد تیرگی و پف دور چشم'
      }, {
        href: '/eye-cream',
        title: 'سرم و کرم دور چشم'
      }, {
        href: '/eye-mask',
        title: 'ماسک دور چشم'
      }]
    }]
  }, {
    categories: [{
      title: 'مراقبت بدن',
      href: '/body-care',
      links: [{
        href: '/body-lotion-body-cream',
        title: 'روغن و لوسیون بدن'
      }, {
        href: '/stretch-marks',
        title: 'ضد ترک و اسکار'
      }, {
        href: '/lightening-for-body',
        title: 'روشن کننده بدن'
      }, {
        href: '/body-scrub',
        title: 'اسکراب بدن'
      }, {
        href: '/lifting-for-body',
        title: 'سفت کننده پوست بدن'
      }, {
        href: '/body-care-set',
        title: 'ست مراقبت بدن'
      }]
    }, {
      title: 'مراقبت لب',
      href: '/lip-care',
      links: [{
        href: '/lip-balm',
        title: 'نرم کننده و بالم لب'
      }, {
        href: '/lip-mask',
        title: 'ماسک و پچ لب'
      }]
    }]
  }, {
    categories: [{
      title: 'مراقبت دست و ناخن',
      href: '/nail-treatment',
      links: [{
        href: '/hand-cream-nail-cream',
        title: 'کرم دست و ناخن'
      }, {
        href: '/nail-strengthener',
        title: 'تقویت کننده ناخن'
      }]
    }, {
      title: 'مراقبت پا',
      href: '/foot-treatment',
      links: [{
        href: '/cracked-foot-cream',
        title: 'کرم ترک پا'
      }, {
        href: '/bath-salt-and-cocktail-pedicure',
        title: 'نمک و کوکتل پا'
      }]
    }]
  }]
}, {
  title: 'مراقبت و زیبایی مو',
  href: '/categories/hair',
  icon: getCdnUrl('/_toad/app-icons/menu/hair-care.svg'),
  id: MobileMenuItems.HairCare,
  isLinkInDrawer: false,
  children: [{
    categories: [{
      title: 'شامپو',
      href: '/shampoo',
      links: [{
        title: 'شامپو موی معمولی',
        href: '/normal-hair-shampoo'
      }, {
        title: 'شامپو موی چرب',
        href: '/oily-hair-shampoo'
      }, {
        title: 'شامپو موی خشک و آسیب‌دیده',
        href: '/dry-hair-shampoo'
      }, {
        title: 'شامپو ضدریزش و تقویت‌کننده',
        href: '/anti-hair-fall-shampoos'
      }, {
        title: 'شامپو ضد شوره',
        href: '/anti-dandruff-shampoo'
      }, {
        title: 'شامپو بدون سولفات',
        href: '/tags/sulfate-free-shampoo',
        useHrefWithoutParent: true
      }, {
        title: 'شامپو کراتینه',
        href: '/keratin-shampoo'
      }, {
        title: 'شامپو رنگ',
        href: '/color-shampoo'
      }, {
        title: 'شامپو خشک',
        href: '/dry-shampoo'
      }]
    }]
  }, {
    categories: [{
      title: 'مراقبت از مو',
      href: '/hair-care',
      links: [{
        title: 'ماسک مو',
        href: '/hair-mask'
      }, {
        title: 'روغن مو',
        href: '/hair-oil'
      }, {
        title: 'سرم مو',
        href: '/hair-serum'
      }, {
        title: 'کرم و لوسیون مو',
        href: '/hair-cream'
      }, {
        title: 'نرم کننده مو',
        href: '/hair-conditioner'
      }, {
        title: 'تونیک و تونر مو',
        href: '/hair-tonic'
      }]
    }]
  }, {
    categories: [{
      title: 'زیبایی مو',
      href: '/hair-makeup',
      links: [{
        title: 'اسپری مو',
        href: '/hair-spray'
      }, {
        title: 'ژل مو',
        href: '/hair-styling-gel'
      }, {
        title: 'چسب مو',
        href: '/hair-glue'
      }, {
        title: 'موس و فوم مو',
        href: '/hair-mousse'
      }, {
        title: 'واکس مو',
        href: '/hair-wax'
      }, {
        title: 'رنگ مو ',
        href: '/hair-color'
      }, {
        title: 'دکلره',
        href: '/hair-bleach'
      }, {
        title: 'اکسیدان',
        href: '/antioxidants'
      }, {
        title: 'واریاسیون',
        href: '/variation'
      }, {
        title: 'پودر پرپشت کننده مو',
        href: '/hair-styling-powder'
      }, {
        title: 'کیت رنگ مو',
        href: '/hair-color-kit'
      }]
    }]
  }, {
    categories: [{
      title: 'ابزار آرایش و پیرایش',
      href: '/hair-cutting-tools',
      links: [{
        title: 'برس و شانه مو',
        href: '/hair-brush-hair-comb'
      }, {
        title: 'ابزار رنگ مو',
        href: '/hair-color-tool'
      }, {
        title: 'ابزار کوتاهی مو',
        href: '/haircut-tools'
      }]
    }]
  }]
}, {
  title: 'بهداشت شخصی و حمام',
  href: '/categories/personal-care-detergents',
  icon: getCdnUrl('/_toad/app-icons/menu/personal-hygiene.svg'),
  id: MobileMenuItems.PersonalHygiene,
  isLinkInDrawer: false,
  children: [{
    categories: [{
      title: 'دئودورانت و ضد تعریق',
      href: '/antiperspirant-deodorant',
      links: [{
        title: 'دئودورانت و ضد تعریق زنانه',
        href: '/deodorant-for-women'
      }, {
        title: 'دئودورانت و ضد تعریق مردانه',
        href: '/men-deodorants'
      }]
    }, {
      title: 'محصولات زناشویی و جنسی',
      href: '/sexual-health',
      links: [{
        title: 'ژل و اسپری زناشویی',
        href: '/delay-gel'
      }, {
        title: 'کاندوم',
        href: '/condom'
      }]
    }]
  }, {
    categories: [{
      title: 'بهداشت دهان و دندان',
      href: '/teeth-and-mouth-care',
      links: [{
        title: 'خمیر دندان',
        href: '/toothbrush'
      }, {
        title: 'نخ دندان',
        href: '/dental-floss'
      }, {
        title: 'دهانشویه',
        href: '/mouthwash'
      }, {
        title: 'مسواک',
        href: '/brush'
      }, {
        title: 'خوشبوکننده دهان',
        href: '/mouth-spray'
      }]
    }]
  }, {
    categories: [{
      title: 'بهداشت بانوان و آقایان',
      href: '/women-men-care',
      links: [{
        title: 'ژل بهداشتی',
        href: '/genital-cleaning-gel'
      }, {
        title: 'نوار بهداشتی',
        href: '/sanitary-pad'
      }, {
        title: 'کاپ قاعدگی',
        href: '/menstrual-cup'
      }]
    }]
  }, {
    categories: [{
      title: 'بدن و حمام',
      href: '/body-wash-bathroom',
      links: [{
        title: 'شامپو بدن و شاورژل',
        href: '/body-shampoo'
      }, {
        title: 'لیف و اسفنج',
        href: '/washcloth'
      }, {
        title: 'صابون',
        href: '/soap'
      }, {
        title: 'مایع دستشویی',
        href: '/washing-liquid'
      }, {
        title: 'خوشبو کننده هوا',
        href: '/categories/personal-care-detergents/requirements/air-freshener',
        useHrefWithoutParent: true
      }]
    }]
  }, {
    categories: [{
      title: 'لوازم اصلاح و پیرایش',
      href: '/shaving',
      links: [{
        title: 'افتر شیو',
        href: '/after-shave'
      }, {
        title: 'خمیر و فوم اصلاح',
        href: '/gel-and-foam-reform'
      }, {
        title: 'تیغ و ژیلت',
        href: '/shave-blade'
      }, {
        title: 'کرم و اسپری موبر',
        href: '/hair-removal-cream-spray'
      }]
    }]
  }]
}, {
  title: 'مکمل غذایی و ورزشی',
  href: '/categories/nutritional-sports-supplement',
  icon: getCdnUrl('/_toad/app-icons/menu/drug.svg'),
  id: MobileMenuItems.Drug,
  isLinkInDrawer: false,
  children: [{
    categories: [{
      title: 'مکمل بدنسازی',
      href: '/bodybuilding-supplements',
      links: [{
        title: 'مکمل پروتئین',
        href: '/proteins'
      }, {
        title: 'پروتئین وی',
        href: '/whey-protein'
      }, {
        title: 'گینر',
        href: '/gainer'
      }, {
        title: 'مکمل bcaa',
        href: '/bcaa'
      }, {
        title: 'آمینو اسید',
        href: '/amino-acids'
      }, {
        title: 'گلوتامین',
        href: '/glutamine'
      }, {
        title: 'ال کارنیتین',
        href: '/l-carnitine'
      }, {
        title: 'ال آرژنین',
        href: '/arginine'
      }, {
        title: 'کراتین',
        href: '/creatine'
      }, {
        title: 'کربوهیدرات',
        href: '/carbohydrate'
      }, {
        title: 'مکمل cla',
        href: '/cla'
      }, {
        title: 'مکمل کافئین',
        href: '/coffein'
      }]
    }]
  }, {
    categories: [{
      title: 'ویتامین و مواد معدنی',
      href: '/nutritional-supplements',
      links: [{
        title: 'مولتی ویتامین',
        href: '/multivitamin'
      }, {
        title: 'کلسیم',
        href: '/calcium'
      }, {
        title: 'زینک و زینک پلاس',
        href: '/zink'
      }, {
        title: 'قرص آهن',
        href: '/iron-folic-acid'
      }, {
        title: 'فولیک اسید',
        href: '/facets/folic-acid',
        useHrefWithoutParent: true
      }, {
        title: 'منیزیم',
        href: '/magnesium'
      }, {
        title: 'ویتامین سی',
        href: '/vitamin-c'
      }, {
        title: 'ویتامین دی',
        href: '/vitamin-d'
      }, {
        title: 'ویتامین ای',
        href: '/vitamin-e'
      }, {
        title: 'ویتامین ب',
        href: '/vitamin-b'
      }, {
        title: 'ویتامین ب کمپلکس',
        href: '/tags/b-complex',
        useHrefWithoutParent: true
      }, {
        title: 'ویتامین b12',
        href: '/tags/vitamin-b12',
        useHrefWithoutParent: true
      }, {
        title: 'ویتامین b6',
        href: '/tags/vitamin-b6',
        useHrefWithoutParent: true
      }, {
        title: 'بیوتین',
        href: '/tags/biotin',
        useHrefWithoutParent: true
      }, {
        title: 'مکمل کودکان',
        href: '/child-supplement'
      }, {
        title: 'کروم',
        href: '/chromium'
      }, {
        title: 'سلنیوم',
        href: '/selenium'
      }]
    }]
  }, {
    categories: [{
      title: 'مکمل گیاهی و درمانی',
      href: '/herbal-supplements',
      links: [{
        title: 'مکمل پوست، مو و ناخن',
        href: '/skin-hair-nails-supplement'
      }, {
        title: 'مکمل تقویت کننده و ضد ریزش مو',
        href: '/tags/anti-hair-loss-strength',
        useHrefWithoutParent: true
      }, {
        title: 'مکمل تقویت سیستم ایمنی بدن',
        href: '/tags/immune-system',
        useHrefWithoutParent: true
      }, {
        title: 'مکمل تسکین‌دهنده درد',
        href: '/soothing-pain-specialist-supplements'
      }, {
        title: 'تقویت قوای جنسی آقایان',
        href: '/men-libido'
      }, {
        title: 'تقویت باروری آقایان',
        href: '/men-fertility'
      }, {
        title: 'مکمل پروستات',
        href: '/prostate'
      }, {
        title: 'تقویت باروری بانوان',
        href: '/women-fertility'
      }, {
        title: 'تقویت میل جنسی بانوان',
        href: '/women-libido'
      }, {
        title: 'مکمل قاعدگی',
        href: '/menstruation'
      }, {
        title: 'مکمل یائسگی',
        href: '/menopause'
      }, {
        title: 'مکمل بارداری و شیردهی',
        href: '/pregnancy-and-lactation'
      }]
    }]
  }, {
    categories: [{
      title: 'مواد مغذی',
      href: '/nutrient-ingredients',
      links: [{
        title: 'رویال ژلی',
        href: '/royal-jelly'
      }, {
        title: 'امگا 3',
        href: '/omega-3'
      }, {
        title: 'گلوکزامین',
        href: '/glucosamine'
      }, {
        title: 'کوآنزیم کیوتن',
        href: '/coenzyme'
      }, {
        title: 'کلاژن',
        href: '/collagen'
      }]
    }]
  }]
}, {
  title: 'عطر و اسپری',
  href: '/categories/scented-products',
  icon: getCdnUrl('/_toad/app-icons/menu/perfume.svg'),
  id: MobileMenuItems.Perfume,
  isLinkInDrawer: false,
  children: [{
    categories: [{
      title: 'عطر و ادکلن',
      href: '/fragrance',
      links: [{
        title: 'عطر زنانه',
        href: '/perfume-for-women'
      }, {
        title: 'عطر مردانه',
        href: '/men-perfume'
      }, {
        title: 'عطر کودک',
        href: '/baby-fragrance'
      }, {
        href: '/tags/unisex-perfume',
        title: 'عطر و ادکلن یونیسکس',
        useHrefWithoutParent: true
      }]
    }]
  }, {
    categories: [{
      title: 'اسپری بدن',
      href: '/body-spray',
      links: [{
        title: 'اسپری زنانه',
        href: '/body-spray-for-women'
      }, {
        title: 'اسپری مردانه',
        href: '/men-body-spray'
      }]
    }]
  }, {
    categories: [{
      title: 'بادی اسلپش',
      href: '/body-splash',
      links: [{
        title: 'بادی اسپلش زنانه',
        href: '/women-body-splash'
      }, {
        title: 'بادی اسپلش مردانه',
        href: '/men-body-splash'
      }]
    }]
  }, {
    categories: [{
      title: 'عطر جیبی',
      href: '/pocket-perfume',
      links: [{
        title: 'عطر جیبی زنانه',
        href: '/women-pocket-perfume'
      }, {
        title: 'عطر جیبی مردانه',
        href: '/men-pocket-perfume'
      }]
    }]
  }]
}, {
  title: 'لوازم برقی',
  href: '/categories/electrical-personal-care',
  icon: getCdnUrl('/_toad/app-icons/menu/appliances.svg'),
  id: MobileMenuItems.Appliancese,
  isLinkInDrawer: false,
  children: [{
    categories: [{
      title: 'ابزار سلامت',
      href: '/health-care',
      links: [{
        title: 'ماساژور',
        href: '/massager'
      }, {
        title: 'دستگاه بخور',
        href: '/humidifier'
      }, {
        title: 'ترازو',
        href: '/scale'
      }, {
        title: 'فشارسنج',
        href: '/sphygomanometer'
      }, {
        title: 'تب سنج',
        href: '/thermometer'
      }, {
        title: 'بالشت طبی',
        href: '/medical-pillow'
      }, {
        title: 'مسواک برقی',
        href: '/electric-brusher'
      }]
    }]
  }, {
    categories: [{
      title: 'ابزار برقی مو',
      href: '/electrical-hair-styling-tools',
      links: [{
        title: 'سشوار',
        href: '/hair-drayer'
      }, {
        title: 'اتو موی صاف کننده',
        href: '/hair-iron'
      }, {
        title: 'فر کننده و حالت دهنده مو',
        href: '/hair-curler'
      }, {
        title: 'برس حرارتی',
        href: '/thermal-styling-brush'
      }]
    }]
  }, {
    categories: [{
      title: 'ابزار اصلاح',
      href: '/shaver',
      links: [{
        title: 'ریش تراش و ماشین اصلاح صورت',
        href: '/shaving-machine'
      }, {
        title: 'موزن بینی و گوش',
        href: '/nose-clipper'
      }, {
        title: 'ماشین اصلاح بدن و سر',
        href: '/hair-trimmer'
      }, {
        title: 'اپیلیدی و بند انداز برقی',
        href: '/female-face-hair-removal'
      }]
    }]
  }, {
    categories: [{
      title: 'ابزار مراقبت پوست',
      href: '/skin-care-accessories',
      links: [{
        title: 'فیس براش و سری یدک',
        href: '/face-brush'
      }, {
        title: 'دستگاه لیفت صورت و جوانساز',
        href: '/skin-rejuvenation-tools'
      }]
    }]
  }]
}, {
  title: 'مد و پوشاک',
  href: '/categories/apparel',
  icon: getCdnUrl('/_toad/app-icons/menu/apparel.svg'),
  id: MobileMenuItems.Apparel,
  isLinkInDrawer: false,
  children: [{
    categories: [{
      title: 'کیف و کوله',
      href: '/bags',
      links: [{
        title: 'کیف زنانه',
        href: '/women-bag'
      }, {
        title: 'کوله پشتی',
        href: '/backpack'
      }]
    }]
  }, {
    categories: [{
      title: 'اکسسوری',
      href: '/accessories',
      links: [{
        title: 'ساعت زنانه',
        href: '/women-watch'
      }, {
        title: 'ساعت مردانه',
        href: '/men-watch'
      }, {
        title: 'ساعت یونیسکس',
        href: '/tags/unisex-watch',
        useHrefWithoutParent: true
      }, {
        title: 'کمربند مردانه',
        href: '/belt'
      }, {
        title: 'جاکلیدی و جاسوئیچی',
        href: '/key-holder'
      }, {
        title: 'کلیپس، گیره و کش مو',
        href: '/hair-accessories'
      }]
    }]
  }, {
    categories: [{
      title: 'زیورآلات',
      href: '/jewelry',
      links: [{
        title: 'گردنبند زنانه',
        href: '/necklace'
      }, {
        title: 'گوشواره زنانه',
        href: '/earrings'
      }, {
        title: 'دستبند زنانه',
        href: '/bracelets'
      }, {
        title: 'انگشتر زنانه',
        href: '/rings'
      }, {
        title: 'پیرسینگ',
        href: '/piercing'
      }]
    }]
  }, {
    categories: [{
      title: 'لباس',
      href: '/clothing',
      links: [{
        title: 'جوراب زنانه',
        href: '/women-socks'
      }, {
        title: 'جوراب مردانه',
        href: '/mens-socks'
      }, {
        title: 'جوراب کودک و نوزاد',
        href: '/kids-socks'
      }, {
        title: 'لباس زیر زنانه',
        href: '/women-underwear'
      }]
    }]
  }]
}, {
  title: 'کالای دیجیتال',
  href: '/categories/electronic-devices',
  icon: getCdnUrl('/_toad/app-icons/menu/electronic-devices.svg'),
  id: MobileMenuItems.ElectronicDevices,
  isLinkInDrawer: false,
  children: [{
    categories: [{
      title: 'هدفون، هندزفری و هدست',
      href: '/headphone'
    }, {
      title: 'ساعت هوشمند',
      href: '/smart-watch'
    }, {
      title: 'اسپیکر',
      href: '/speaker'
    }, {
      title: 'پاوربانک',
      href: '/power-bank'
    }]
  }, {
    categories: [{
      title: 'لوازم جانبی',
      href: '/digital-accessories',
      links: [{
        title: 'کابل شارژ و مبدل',
        href: '/data-cable'
      }, {
        title: 'شارژر موبایل',
        href: '/cell-phone-charger'
      }, {
        title: 'هولدر موبایل',
        href: '/smartphone-holder'
      }, {
        title: 'موس',
        href: '/mouse'
      }, {
        title: 'کیبورد',
        href: '/keyboard'
      }, {
        title: 'قطعات جانبی',
        href: '/accessory-parts'
      }]
    }]
  }]
}, {
  title: 'طلا و نقره',
  href: '/categories/gold-silver',
  icon: getCdnUrl('/_toad/app-icons/menu/gold-silver.svg'),
  id: MobileMenuItems.goldSilver,
  isLinkInDrawer: false,
  children: [{
    categories: [{
      title: 'زیورآلات نقره',
      href: '/silver-jewelry',
      links: [{
        title: 'دستبند نقره',
        href: '/women-silver-bracelet'
      }, {
        title: 'گردنبند نقره',
        href: '/women-silver-necklace'
      }, {
        title: 'گوشواره  نقره',
        href: '/women-silver-earrings'
      }, {
        title: 'چارم پاندورا',
        href: '/charms'
      }]
    }]
  }, {
    categories: [{
      title: 'زیورآلات طلا',
      href: '/gold-jewels',
      links: [{
        title: 'انگشتر طلا زنانه',
        href: '/gold-ring'
      }, {
        title: 'گردنبند طلا زنانه',
        href: '/gold-necklace'
      }, {
        title: 'آویز طلا',
        href: '/gold-pendant'
      }, {
        title: 'گوشواره طلا زنانه',
        href: '/gold-earrings'
      }, {
        title: 'دستبند طلا زنانه',
        href: '/gold-bracelets'
      }, {
        title: 'دستبند طلا مردانه',
        href: '/men-gold-bracelet'
      }]
    }]
  }, {
    categories: [{
      title: 'شمش و سکه',
      href: '/bullion'
    }]
  }]
}, {
  title: 'مادر و کودک',
  href: '/categories/kids-care',
  icon: getCdnUrl('/_toad/app-icons/menu/kids-care.svg'),
  id: MobileMenuItems.kidsCare,
  isLinkInDrawer: false,
  children: [{
    categories: [{
      title: 'بهداشت و مراقبت از کودک',
      href: '/baby-health-and-bathroom-tools',
      links: [{
        title: 'کرم، لوسیون و روغن کودک',
        href: '/baby-body-lotion'
      }, {
        title: 'شامپو بچه',
        href: '/baby-shampoo'
      }, {
        title: 'شامپو بدن بچه',
        href: '/baby-body-shampoo'
      }, {
        title: 'دستمال مرطوب کودک',
        href: '/baby-wep-wipes'
      }, {
        title: 'خمیر دندان کودک',
        href: '/baby-toothpaste'
      }, {
        title: 'مسواک کودک',
        href: '/baby-toothbrush'
      }, {
        title: 'پوشک بچه',
        href: '/baby-diaper'
      }, {
        title: 'ضدآفتاب کودک',
        href: '/categories/kids-care/baby-sunblock',
        useHrefWithoutParent: true
      }]
    }]
  }, {
    categories: [{
      title: 'لوازم تغذیه کودک',
      href: '/baby-feeding',
      links: [{
        title: 'شیشه شیر',
        href: '/baby-bottle'
      }]
    }]
  }]
}, {
  title: 'مجله خانومی',
  href: 'https://www.khanoumi.com/blog/',
  icon: getCdnUrl('/_toad/app-icons/menu/mag.svg'),
  id: MobileMenuItems.Mag,
  isLinkInDrawer: true,
  hideOnMobile: true
}];
export const PAGE_SIZE_OF_BRANDS = 22;
export const Alphabets = ['آ', 'ب', 'پ', 'ت', 'ث', 'ج', 'چ', 'ح', 'خ', 'د', 'ذ', 'ر', 'ز', 'ژ', 'س', 'ش', 'ص', 'ض', 'ط', 'ظ', 'ع', 'غ', 'ف', 'ق', 'ک', 'گ', 'ل', 'م', 'ن', 'و', 'ه', 'ی'];